<template>
  <div :class="{'h-full flex items-center justify-center' : !orderProducts.length}">
    <template v-if="orderProducts.length || !touch">
      <div class="wrapper-y-spacer"></div>
      <div :class="seeLastRecord" class="w-full md:w-11/12 md:mx-auto 2xl:w-full">
        <table-visual-rank
          v-if="view === 'table'"
          v-model="selectedItems"
          :data="orderProducts"
          :loading="loading"
          @selected="onSelectProduct"
        />
        <visual-rank-card-view
          v-else
          v-model="selectedItems"
          :data="orderProducts"
          :loading="loading"
          @selected="onSelectProduct"
        />
        <div class="wrapper-y-spacer"></div>
      </div>
    </template>
    <template v-else>
      <base-not-found />
    </template>

    <!-- boton Análisis de la competencia -->
    <banner-start-feature-layout :isOpen="!!selectedItems.length">
      <template slot="image">
        <img
          src="@/assets/img/svg-competencia.svg"
          alt="Iniciar análisis de la competencia"
        >
      </template>
      <template slot="body">
        <h4 class="leading-tight font-semibold">{{ $t('app.competitorAnalysis') }}</h4>
        <span class="text-sm text-secondary-100 ">{{ $tc('app.selectedItemsCounter', selectedItems.length) }}</span>
      </template>
      <template slot="actions">
        <base-button
          size="xs"
          @click="resetCompetition"
          mode="secondary"
        >{{ $t('app.cancel') }}</base-button>
        <base-button
          size="xs"
          @click="toggleCompetitionModal"
        >{{ $t('app.start') }}</base-button>
      </template>
    </banner-start-feature-layout>

    <!-- filtros y modales -->
    <product-detail-panel
      v-if="productDetail"
      :key="productDetailKey"
      :panelOpen="true"
      :data="productDetail"
      @close="closeProductPanel"
    />
    <competition-modal
      v-bind:horizontal="false"
      v-model="selectedItems"
      :toggle="competitionModal"
      @toggleModal="toggleCompetitionModal"
    />
  </div>
</template>

<script>
import TableVisualRank from '@/components/tables/TableVisualRank.vue'
import ProductDetailPanel from '@/components/ProductDetailPanel.vue'
import CompetitionModal from '@/components/modalViews/CompetitionModal.vue'
import VisualRankCardView from '@/components/VisualRankCardView.vue'
import BannerStartFeatureLayout from '@/layouts/BannerStartFeatureLayout.vue'
import moment from 'moment'
import { getVisualRank } from '@/services/visual-rank/getVisualRank'
import { getCurrencyFormat, getDecimalFormat } from '@/i18n/numbers'
import csvMixin from '@/mixins/csvMixin'

const { parse } = require('json2csv')

export default {
  name: 'VisualRank',
  components: {
    TableVisualRank,
    ProductDetailPanel,
    CompetitionModal,
    VisualRankCardView,
    BannerStartFeatureLayout
  },
  mixins: [csvMixin],
  data: function () {
    return {
      touch: false,
      products: [],
      competitionModal: false,
      productDetail: null,
      selectedItems: [],
      loading: false,
      csvLinks: [
        { ref: 'visualRank', title: this.$t('app.visualRank'), subtitle: this.$t('csv.file') }
      ]
    }
  },
  computed: {
    countryCode: function () {
      return this.$store.getters['filters/countryCode']
    },
    csvFieldOptions: function () {
      const locale = this.$store.getters['auth/locale']
      return this.$store.getters['filters/csvFieldOptions'](locale)
    },
    csvOptions: function () {
      const fields = []
      fields.push('brandName', 'name')
      fields.push(...this.csvFieldOptions)
      fields.push('pvp', 'visualRank', 'link', 'imageUrl')

      return {
        delimiter: ';',
        fields
      }
    },
    filterChangeCounter: function () {
      return this.$store.getters['filters/changeCounter']
    },
    selectedFilter1: function () {
      return this.$store.getters['filters/selectedDimensions'].filter1
    },
    selectedFilter2: function () {
      return this.$store.getters['filters/selectedDimensions'].filter2
    },
    selectedFilter3: function () {
      return this.$store.getters['filters/selectedDimensions'].filter3
    },
    selectedFilter4: function () {
      return this.$store.getters['filters/selectedDimensions'].filter4
    },
    selectedFilter5: function () {
      return this.$store.getters['filters/selectedDimensions'].filter5
    },
    selectedFilter6: function () {
      return this.$store.getters['filters/selectedDimensions'].filter6
    },
    selectedFilter7: function () {
      return this.$store.getters['filters/selectedDimensions'].filter7
    },
    selectedFilter8: function () {
      return this.$store.getters['filters/selectedDimensions'].filter8
    },
    selectedFilter9: function () {
      return this.$store.getters['filters/selectedDimensions'].filter9
    },
    selectedFilter10: function () {
      return this.$store.getters['filters/selectedDimensions'].filter10
    },
    view: function () {
      return this.$store.getters['filters/view']
    },
    groupId: function () {
      return this.$store.getters['filters/groupId']
    },
    categoryId: function () {
      return this.$store.getters['filters/categoryId']
    },
    siteId: function () {
      return this.$store.getters['filters/siteId']
    },
    startDate: function () {
      return this.$store.getters['filters/startDate']
    },
    endDate: function () {
      return this.$store.getters['filters/endDate']
    },
    minPrice: function () {
      return this.$store.getters['filters/minPrice']
    },
    maxPrice: function () {
      return this.$store.getters['filters/maxPrice']
    },
    // Cuando aparece el botón de analizar competencia creamos este espacio para que se pueda ver el último registro
    seeLastRecord: function () {
      return {
        'pb-20': !!this.selectedItems.length,
        '2xl:pl-10 2xl:pr-6 ': this.view === 'table'
      }
    },
    csvChangeCounter: function () {
      return this.$store.getters['app/csvCounter']
    },
    csvData: function () {
      let data = [...this.orderProducts]
      data = data.map(item => {
        const i = { ...item }
        i.pvp = item.pvp ? getCurrencyFormat(item.pvp, this.countryCode) : null
        i.visualRank = item.visualRank ? getDecimalFormat(item.visualRank) : null
        return i
      })

      return parse(data, this.csvOptions)
    },
    activeOrder: function () {
      return this.$store.getters['filters/activeOrder']
    },
    orderProducts: function () {
      const products = [...this.products]
      const activeOrder = this.activeOrder
      if (activeOrder && !!activeOrder.order) {
        products.sort((a, b) => {
          if (typeof a[activeOrder.prop] === 'number') {
            return (a[activeOrder.prop] - b[activeOrder.prop]) * activeOrder.order
          } else if (typeof a[activeOrder.prop] === 'boolean') {
            return (a[activeOrder.prop] < b[activeOrder.prop] ? 1 : (a[activeOrder.prop] > b[activeOrder.prop] ? -1 : 0)) * activeOrder.order
          } else {
            return (a[activeOrder.prop] < b[activeOrder.prop] ? 1 : (a[activeOrder.prop] > b[activeOrder.prop] ? -1 : 0)) * activeOrder.order
          }
        })
      }
      return products
    },
    selectedHealthIndexFilter: function () {
      return this.$store.getters['filters/healthIndexFilter'].selected
    },
    productDetailKey: function () {
      return this.productDetail ? this.productDetail.idPrice : null
    }
  },
  created: async function () {
    this.$store.commit('app/setCsvLinks', this.csvLinks)
    try {
      this.$store.commit('app/setLoading', true)
      await this.downloadingData()
    } catch (error) {
      this.doFeedback()
    } finally {
      this.$store.commit('app/setLoading', false)
    }
  },
  watch: {
    filterChangeCounter: function () {
      this.downloadingData()
    },
    csvChangeCounter: function () {
      this.downloadCsv(this.csvData, 'visual-rank')
    }
  },
  methods: {
    downloadingData: async function () {
      try {
        this.loading = true
        await this.fetchVisualRank()
      } catch (error) {
        this.doFeedback()
      } finally {
        this.touch = true
        this.loading = false
      }
    },
    fetchVisualRank: async function () {
      const groupId = this.groupId
      const categoryId = this.categoryId
      const siteId = this.siteId
      const startDate = moment(this.startDate).format('DD-MM-YYYY')
      const endDate = moment(this.endDate).format('DD-MM-YYYY')
      const body = {
        precioMin: this.minPrice,
        precioMax: this.maxPrice
      }

      if (this.selectedHealthIndexFilter && this.selectedHealthIndexFilter.length === 1) {
        body.healthIndex = this.selectedHealthIndexFilter[0].toString()
      }
      if (this.selectedFilter1 && this.selectedFilter1.length) {
        body.filtro1 = this.selectedFilter1
      }
      if (this.selectedFilter2 && this.selectedFilter2.length) {
        body.filtro2 = this.selectedFilter2
      }
      if (this.selectedFilter3 && this.selectedFilter3.length) {
        body.filtro3 = this.selectedFilter3
      }
      if (this.selectedFilter4 && this.selectedFilter4.length) {
        body.filtro4 = this.selectedFilter4
      }
      if (this.selectedFilter5 && this.selectedFilter5.length) {
        body.filtro5 = this.selectedFilter5
      }
      if (this.selectedFilter6 && this.selectedFilter6.length) {
        body.filtro6 = this.selectedFilter6
      }
      if (this.selectedFilter7 && this.selectedFilter7.length) {
        body.filtro7 = this.selectedFilter7
      }
      if (this.selectedFilter8 && this.selectedFilter8.length) {
        body.filtro8 = this.selectedFilter8
      }
      if (this.selectedFilter9 && this.selectedFilter9.length) {
        body.filtro9 = this.selectedFilter9
      }
      if (this.selectedFilter10 && this.selectedFilter10.length) {
        body.filtro10 = this.selectedFilter10
      }

      const data = await getVisualRank(groupId, categoryId, siteId, startDate, endDate, body)

      this.products = data.productos

      this.$store.commit('filters/setHealthIndexOK', data.healthIndexOK)
      this.$store.commit('filters/setHealthIndexKO', data.healthIndexKO)
      this.$store.commit('filters/setFilters', {
        filter1: data.filtro1,
        filter2: data.filtro2,
        filter3: data.filtro3,
        filter4: data.filtro4,
        filter5: data.filtro5,
        filter6: data.filtro6,
        filter7: data.filtro7,
        filter8: data.filtro8,
        filter9: data.filtro9,
        filter10: data.filtro10
      })

      this.$store.commit('filters/setResultsCounter', this.products.length)
    },
    resetCompetition: function () {
      this.selectedItems = []
    },
    toggleCompetitionModal: function () {
      this.competitionModal = !this.competitionModal
    },
    onSelectProduct: function (product) {
      this.productDetail = product
    },
    closeProductPanel: function () {
      this.productDetail = null
    }
  }
}
</script>
